
/* ==========================================================================
   KINOVA — Data Layer (Bosqich 3: real ma'lumot adapteri, Bosqich 4: +CURRENT_USER)

   ⚠️ BOSQICH 3 GACHA bu fayl to'liq statik DEMO ma'lumotni o'zida saqlagan
      edi (MOVIES/SERIES/GENRES/COUNTRIES massivlari to'g'ridan-to'g'ri shu
      yerda yozilgan). ARCHITECTURE.md §6.6 rejasiga ko'ra endi bu KATALOG
      qismi `window.KDATA_BOOTSTRAP` dan o'qiladi — uni server
      (layouts/app.blade.php + App\View\Composers\KdataBootstrapComposer)
      HAQIQIY DB'dan quradi va HAR bir sahifada `<script>` tegi orqali
      in'ektsiya qiladi (Blade `@json`, xavfsiz — JSON_HEX_* bayroqlari
      bilan).

      NATIJA (ARCHITECTURE.md §6.6 dan iqtibos): "components.js, home.js,
      details.js — bironta qatori o'zgarmaydi." `window.KDATA`ning tashqi
      shakli (GENRES/COUNTRIES/MOVIES/SERIES/getMovieBySlug/...) AYNAN
      bir xil qoladi — faqat MANBA o'zgardi. Shuning uchun bu fayl BOSHQA
      HECH BIR skript uchun "sanctioned exception" (ARCHITECTURE.md §6.6):
      loyihada CSS/JS assetlar bayt-bayt saqlanishi shart, lekin bu FAYL
      real ma'lumotga ulanish uchun ATAYLAB o'zgartiriladi (
      scripts/verify-*-assets tekshiruvida aniq ro'yxatga olingan).

   ⚠️ ADMIN qismi (ADMIN_STATS/VIEWS_CHART/GENRE_DISTRIBUTION/ADMIN_USERS):
      Bosqich 3.6'da `App\Support\Kdata\AdminStatsService` HAQIQIY DB'dan
      hisoblaydigan qiladi, lekin `config('kinova.admin_real_stats')`
      bayrog'i ORQASIGA yashiringan (standart: O'CHIRILGAN) — chunki real
      statistika hozirgi tasdiqlangan baseline raqamlaridan farq qiladi,
      bu mahsulot qarori, foydalanuvchi tasdig'ini kutadi (AdminStatsService
      sarlavha izohiga qarang). Shu bayroq yoqilganda `layouts/admin.
      blade.php` `window.KDATA_ADMIN_STATS`ni chiqaradi, pastdagi
      `realAdmin` shuni o'qiydi — aks holda (standart) to'rtta massiv ham
      hozirgi qattiq kodlangan qiymatiga fallback qiladi, ZERO o'zgarish.
      `PROFILE_DEMO` bu mexanizmga KIRMAYDI — hech bir hozirgi sahifa/skript
      uni iste'mol qilmaydi (profil sahifasi hali qurilmagan), shuning
      uchun qattiq kodlangan bo'lib qoladi.
   ========================================================================== */

(function (global) {

  var boot = global.KDATA_BOOTSTRAP || {};

  /* ---- Katalog — HAQIQIY DB'dan (bootstrap orqali) ---- */
  var GENRES = boot.genres || [];
  var COUNTRIES = boot.countries || [];
  var MOVIES = boot.movies || [];
  var SERIES = boot.series || [];

  /* ---- Ommaviy sozlamalar (Bosqich 13) ----
     Ijtimoiy tarmoq havolalari va aloqa ma'lumoti — footer'ni
     components.js klient tomonda quradi, shuning uchun bu qiymatlar
     bootstrap orqali keladi (App\Support\Kdata\Catalog::all()).
     Sozlanmagan bo'lsa bo'sh obyekt — footer o'sha havolani UMUMAN
     chiqarmaydi (o'lik `href="#"` bo'lmasligi uchun). */
  var SETTINGS = boot.settings || {};

  /* ---- Joriy foydalanuvchi (Bosqich 4) ----
     ⚠️ ATAYLAB `boot` ICHIDA EMAS: App\Support\Kdata\Catalog::all() butun
     saytga umumiy `Cache::remember('kdata:catalog:v1', ...)` bilan
     keshlanadi (App\View\Composers\KdataBootstrapComposer) — foydalanuvchiga
     xos ma'lumotni shu strukturaga qo'shish HAR BIR so'rov keshlangan
     javobni ko'rishi degani (bitta foydalanuvchi boshqasining ismini
     ko'rishi mumkin bo'lardi). Shuning uchun alohida, so'rov-boshiga xos
     global: `window.KDATA_CURRENT_USER` (composer'da alohida `with()`).
     Mehmon uchun har doim `null` — components.js header()/mobileMenu()/
     footer() shu holatni "Kirish" havolasi bilan ko'rsatadi (o'zgarishsiz). */
  var CURRENT_USER = global.KDATA_CURRENT_USER || null;

  /* ---- Admin: statistika ----
     Bosqich 3.6 (gated, standart O'CHIRILGAN — App\Support\Kdata\
     AdminStatsService sarlavha izohiga qarang): `config('kinova.
     admin_real_stats')` yoqilsagina `layouts/admin.blade.php`
     `window.KDATA_ADMIN_STATS`ni chiqaradi; aks holda bu global umuman
     mavjud emas va `realAdmin` quyida `null` bo'lib qoladi — BARCHA to'rt
     massiv o'zining hozirgi qattiq kodlangan qiymatiga fallback qiladi
     (xatti-harakat 100% hozirgi bilan bir xil, GENRES/MOVIES bilan bir xil
     adapter naqshi — faqat fallback `[]` o'rniga TO'LIQ demo qiymat). */
  var realAdmin = global.KDATA_ADMIN_STATS || null;

  var ADMIN_STATS = (realAdmin && realAdmin.stats) || {
    totalMovies: 1248,
    totalSeries: 356,
    totalUsers: 84920,
    totalViews: 12400000,
    onlineUsers: 1342,
    trends: { movies: '+4.2%', series: '+2.8%', users: '+8.6%', views: '+14.1%', online: '+1.1%' }
  };

  var VIEWS_CHART = (realAdmin && realAdmin.viewsChart) || [3200, 4100, 3800, 5200, 4700, 6100, 5800, 7200, 6900, 8400, 7900, 9200, 8800, 10400];
  var GENRE_DISTRIBUTION = (realAdmin && realAdmin.genreDistribution) || [
    { name: 'Action', pct: 24 }, { name: 'Drama', pct: 20 }, { name: 'Comedy', pct: 16 },
    { name: 'Sci-Fi', pct: 14 }, { name: 'Animation', pct: 12 }, { name: 'Boshqa', pct: 14 }
  ];

  /* ---- Admin: foydalanuvchilar jadvali (hozircha demo, Bosqich 3.6 gated — yuqoriga qarang) ---- */
  var ADMIN_USERS = (realAdmin && realAdmin.users) || [
    { name: 'Sardor Aliyev', email: 'sardor.aliyev@mail.uz', phone: '+998 90 123 45 67', role: 'Admin', status: 'Active', registered: '2023-01-12', lastLogin: '2026-08-15 09:20' },
    { name: 'Dilnoza Karimova', email: 'dilnoza.k@gmail.com', phone: '+998 91 234 56 78', role: 'Moderator', status: 'Active', registered: '2023-03-05', lastLogin: '2026-08-16 07:40' },
    { name: 'Javlon Tursunov', email: 'javlon.t@gmail.com', phone: '+998 93 345 67 89', role: 'User', status: 'Active', registered: '2023-05-22', lastLogin: '2026-08-14 21:10' },
    { name: 'Madina Yusupova', email: 'madina.y@mail.uz', phone: '+998 94 456 78 90', role: 'User', status: 'Active', registered: '2023-06-14', lastLogin: '2026-08-16 06:55' },
    { name: 'Otabek Rashidov', email: 'otabek.r@gmail.com', phone: '+998 97 567 89 01', role: 'User', status: 'Banned', registered: '2022-11-30', lastLogin: '2026-05-02 14:12' },
    { name: 'Nilufar Ergasheva', email: 'nilufar.e@gmail.com', phone: '+998 88 678 90 12', role: 'User', status: 'Active', registered: '2024-01-09', lastLogin: '2026-08-15 18:30' },
    { name: 'Bekzod Nazarov', email: 'bekzod.n@mail.uz', phone: '+998 90 789 01 23', role: 'Moderator', status: 'Active', registered: '2022-08-18', lastLogin: '2026-08-13 11:05' },
    { name: 'Zarina Xolmatova', email: 'zarina.x@gmail.com', phone: '+998 91 890 12 34', role: 'User', status: 'Pending', registered: '2026-08-10', lastLogin: '—' },
    { name: 'Jasur Umarov', email: 'jasur.u@gmail.com', phone: '+998 93 901 23 45', role: 'User', status: 'Active', registered: '2023-09-27', lastLogin: '2026-08-16 08:02' },
    { name: 'Kamola Saidova', email: 'kamola.s@mail.uz', phone: '+998 94 012 34 56', role: 'User', status: 'Active', registered: '2023-02-16', lastLogin: '2026-08-12 19:44' },
    { name: 'Sherzod G\'oyipov', email: 'sherzod.g@gmail.com', phone: '+998 97 123 45 67', role: 'User', status: 'Banned', registered: '2022-12-01', lastLogin: '2026-03-21 10:00' },
    { name: 'Feruza Tojiboyeva', email: 'feruza.t@gmail.com', phone: '+998 88 234 56 78', role: 'User', status: 'Active', registered: '2024-04-19', lastLogin: '2026-08-16 05:15' },
    { name: 'Aziz Mirzayev', email: 'aziz.m@gmail.com', phone: '+998 90 345 67 89', role: 'User', status: 'Active', registered: '2023-07-08', lastLogin: '2026-08-11 22:30' },
    { name: 'Gulnora Abdullayeva', email: 'gulnora.a@mail.uz', phone: '+998 91 456 78 90', role: 'User', status: 'Active', registered: '2023-10-03', lastLogin: '2026-08-15 13:48' },
    { name: 'Doniyor Xasanov', email: 'doniyor.h@gmail.com', phone: '+998 93 567 89 01', role: 'User', status: 'Pending', registered: '2026-08-14', lastLogin: '—' },
    { name: 'Shahzoda Yoldosheva', email: 'shahzoda.y@gmail.com', phone: '+998 94 678 90 12', role: 'User', status: 'Active', registered: '2024-02-27', lastLogin: '2026-08-16 09:00' },
    { name: 'Ravshan Qodirov', email: 'ravshan.q@mail.uz', phone: '+998 97 789 01 23', role: 'Admin', status: 'Active', registered: '2022-05-14', lastLogin: '2026-08-16 08:50' },
    { name: 'Malika Sobirova', email: 'malika.s@gmail.com', phone: '+998 88 890 12 34', role: 'User', status: 'Active', registered: '2023-11-21', lastLogin: '2026-08-10 16:20' },
    { name: 'Ulug\'bek Toshpo\'latov', email: 'ulugbek.t@gmail.com', phone: '+998 90 901 23 45', role: 'User', status: 'Active', registered: '2024-03-15', lastLogin: '2026-08-09 20:05' },
    { name: 'Sevinch Ibrohimova', email: 'sevinch.i@gmail.com', phone: '+998 91 012 34 56', role: 'User', status: 'Banned', registered: '2023-04-02', lastLogin: '2026-06-18 12:00' },
    { name: 'Anvar Yusupov', email: 'anvar.y@mail.uz', phone: '+998 93 123 45 67', role: 'User', status: 'Active', registered: '2024-05-30', lastLogin: '2026-08-16 07:10' },
    { name: 'Diyora Nematova', email: 'diyora.n@gmail.com', phone: '+998 94 234 56 78', role: 'User', status: 'Active', registered: '2023-08-17', lastLogin: '2026-08-15 23:59' }
  ];

  /* ---- Profil demo ma'lumotlari (hozircha demo) ---- */
  var PROFILE_DEMO = {
    name: 'Sardor Aliyev',
    email: 'sardor.aliyev@example.com',
    phone: '+998 90 123 45 67',
    initials: 'SA',
    memberSince: '2023',
    favorites: ['movie-example', 'qirol-vasiyati', 'chin-dostlik', 'kichik-qahramonlar', 'dostlar-olami', 'muhabbat-kodi'],
    continueWatching: [
      { slug: 'movie-example', progress: 41 },
      { slug: 'zulmat-qonuni', progress: 78 },
      { slug: 'tungi-shahar', progress: 62, episode: 'S1 · 4-qism' },
      { slug: 'kumush-galaktika', progress: 15 }
    ],
    history: [
      { slug: 'oxirgi-bekat', watchedAt: '2026-08-14' },
      { slug: 'songgi-nafas', watchedAt: '2026-08-12' },
      { slug: 'chin-dostlik', watchedAt: '2026-08-10' },
      { slug: 'qirol-vasiyati', watchedAt: '2026-08-07' },
      { slug: 'sirli-orol', watchedAt: '2026-08-03' },
      { slug: 'temir-yurak', watchedAt: '2026-07-29' }
    ]
  };

  /* ---- Har bir elementga turini belgilash (aralash ro'yxatlar uchun, masalan Multfilmlar) ----
     ⚠️ HAQIQIY bootstrap elementlari allaqachon `type` maydoniga ega
        (App\Support\Kdata\ContentTransformer::toItem()) — bu shunchaki
        himoya chorasi (masalan bootstrap bo'sh/eski shaklda bo'lsa ham
        pastdagi kod yiqilib qolmasligi uchun), original kod bilan bir xil. */
  MOVIES.forEach(function (m) { m.type = 'movie'; });
  SERIES.forEach(function (s) { s.type = 'series'; });

  /* ---- Yordamchi getterlar (o'zgarmagan — faqat MOVIES/SERIES manbasi o'zgardi) ---- */
  function getMovieBySlug(slug) {
    for (var i = 0; i < MOVIES.length; i++) if (MOVIES[i].slug === slug) return MOVIES[i];
    return null;
  }
  function getSeriesBySlug(slug) {
    for (var i = 0; i < SERIES.length; i++) if (SERIES[i].slug === slug) return SERIES[i];
    return null;
  }
  function getAnyBySlug(slug) {
    return getMovieBySlug(slug) || getSeriesBySlug(slug);
  }
  function getGenre(name) {
    for (var i = 0; i < GENRES.length; i++) if (GENRES[i].name === name) return GENRES[i];
    return { name: name, label: name, icon: 'tag' };
  }

  global.KDATA = {
    GENRES: GENRES,
    COUNTRIES: COUNTRIES,
    MOVIES: MOVIES,
    SERIES: SERIES,
    SETTINGS: SETTINGS,
    CURRENT_USER: CURRENT_USER,
    ADMIN_STATS: ADMIN_STATS,
    VIEWS_CHART: VIEWS_CHART,
    GENRE_DISTRIBUTION: GENRE_DISTRIBUTION,
    ADMIN_USERS: ADMIN_USERS,
    PROFILE_DEMO: PROFILE_DEMO,
    getMovieBySlug: getMovieBySlug,
    getSeriesBySlug: getSeriesBySlug,
    getAnyBySlug: getAnyBySlug,
    getGenre: getGenre
  };

})(window);
